import Vue from 'vue'
import store from './store'
import App from './App.vue'
import firebase from 'firebase'
import './registerServiceWorker.js'
import router from './router'
import config from './config'
import alertify from 'alertifyjs'
import './../node_modules/alertifyjs/build/css/alertify.min.css'
import VueCarousel from 'vue-carousel'
import { mapState } from 'vuex'
import Vue2TouchEvents from 'vue2-touch-events'
require('./mystyle.scss')
Vue.use(Vue2TouchEvents, {
  disableClick: true
})
Vue.use(VueCarousel, { paginationSize: 5 })

Vue.config.productionTip = false

// Initialize Firebase
// firebase.initializeApp(config.firebaseConfig)

const requireComponent = require.context(
  // Look for files in the current directory
  './components',
  // Do not look in subdirectories
  false,
  // Only include "_base-" prefixed .vue files
  /_base-[\w-]+\.vue$/
)
// For each matching file name...
requireComponent.keys().forEach((fileName) => {
  // Get the component config
  const componentConfig = requireComponent(fileName)
  // Get the PascalCase version of the component name
  const componentName = fileName
    // Remove the "./_base" from the beginning
    .replace(/^\.\/_base/, '')
    // Remove the file extension from the end
    .replace(/\.\w+$/, '')
    // Split up kebabs
    .split('-')
    // Upper case
    .map((kebab) => kebab.charAt(0).toUpperCase() + kebab.slice(1))
    // Concatenated
    .join('')
  // Globally register the component
  Vue.component(componentName, componentConfig.default || componentConfig)
})
Object.defineProperty(Vue.prototype, '$alertify', { value: alertify })

new Vue({
  data: {
    config: {
      predefinedPassword: config.predefinedPassword,
      locations: config.locations,
      episodes: config.episodes,
      initialProgress: config.initialProgress
    }
  },
  router: router,
  render: h => h(App),
  methods: {
  },
  computed: {
    ...mapState({
      progress: state => state.progress,
      locations: state => state.locations,
      progressAlias: 'progress'
    }),
    isOnline () {
      var connectedRef = firebase.database().ref('.info/connected')
      var connected
      connectedRef.on('value', snap => {
        if (snap.val() === true) {
          connected = true
        } else {
          connected = false
        }
      })
      return connected
    }
  },
  store
}).$mount('#app')
